import type { RouteRecordRaw } from 'vue-router'

import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'

import requireWebview from './middleware/requireWebview'
import { OUTLET } from './routes-names'

// Outlet is an iOS-webview-only experience. We declare the routes here and
// run them through `generateWebviewRoutes`, which prefixes them with
// `/webview` and tags them with `isWebview: true`. The `requireWebview`
// middleware on each route 404s any non-webview client, so there is no
// public desktop equivalent.
//
// The detail route is namespaced under `/product` to avoid colliding with the
// category list route, whose `:slug` would otherwise swallow any product id.
export default (): RouteRecordRaw[] => {
  const outletRoutes: RouteRecordRaw[] = [
    {
      path: 'outlet',
      name: OUTLET.HOME,
      component: () =>
        import('~/scopes/outlet/pages/OutletHome/OutletHome.vue'),
      meta: {
        owners: ['bot-squad-acquisition-front'],
        middleware: [requireWebview],
      },
    },
    {
      path: 'outlet/product/:id',
      name: OUTLET.DETAIL,
      component: () =>
        import('~/scopes/outlet/pages/OutletDetail/OutletDetail.vue'),
      meta: {
        owners: ['bot-squad-acquisition-front'],
        middleware: [requireWebview],
      },
    },
    {
      path: 'outlet/:slug',
      name: OUTLET.CATEGORY,
      component: () =>
        import('~/scopes/outlet/pages/OutletCategory/OutletCategory.vue'),
      meta: {
        owners: ['bot-squad-acquisition-front'],
        middleware: [requireWebview],
      },
    },
  ]

  return generateWebviewRoutes(outletRoutes)
}
